<template>
    <div class="kiosk-locations-index">
      <Breadcrumbs
        :breadcrumbs="[
        { title: this.$t('menu.audiology'), disabled: true },
        { title: this.$t('menu.kiosklocations'), disabled: true }
      ]">
        <div slot="breadcrumbAfter" class="d-flex align-items-center">
          <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />

          <div class="btn btn__floating btn__round__large btn__round__large">
            <va-popover
              class="mr-3"
              placement="left"
              :message="$t('placings.create_placing')"
            >
            <span class="btn__round">
              <va-button
                id="btn-create-placing"
                @click.prevent="handleCreatePlacing">
                <i class="fa fa-plus"></i>
              </va-button>
            </span>
            </va-popover>
          </div>
        </div>
      </Breadcrumbs>

    <LocationsTable
      ref="placingsTable"
      :entities=entities
      :showFilters.sync="showFilters"
      @filters-updated="onFiltersUpdated"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @selectedPlacing="handleSelectedPlacing"/>

    <PlacingDetailsAction v-if="showPlacingDetailsAction"
      :entities="entities"
      :is-creating="isCreating"
      :selected-placing="selectedPlacing"
      @canceled="handleModalCanceled"
      @created="handlePlacingCreated"
      @updated="handlePlacingUpdated"
      @deleted="handlePlacingDeleted"
    />
  </div>
</template>

<script>
import LocationsTable from '@/components/kiosklocations/LocationsTable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import PlacingDetailsAction from '@/components/kiosklocations/PlacingDetailsAction'
import { TABLE_KIOSK_LOCATIONS } from '@/local-storage/LocalStorageKeys'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'

export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: {
    Searchable,
    PlacingDetailsAction,
    Breadcrumbs,
    LocationsTable,
    Filters
  },
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      showPlacingDetailsAction: false,
      selectedPlacing: null,
      isloading: false,
      isCreating: false,
      showEditPlacing: false,
      showDeleteConfirmation: false,
      querySearch: '',
      customQueries: null,
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_KIOSK_LOCATIONS,
    }
  },
  methods: {
    handleCreatePlacing: function () {
      this.isCreating = true
      this.showPlacingDetailsAction = true
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    handleSelectedPlacing: function (row) {
      this.selectedPlacing = row.row
      this.showPlacingDetailsAction = true
    },
    handleModalCanceled: function () {
      this.selectedPlacing = null
      this.isCreating = false
      this.showPlacingDetailsAction = false
    },
    handlePlacingCreated: function () {
      this.showPlacingDetailsAction = false
      this.showToast(this.$t('placings.created_success'), this.$store.state.successToastOptions)
      this.reloadTable()
    },
    handlePlacingUpdated: function () {
      this.selectedPlacing = null
      this.showPlacingDetailsAction = false
      this.showToast(this.$t('placings.placing_updated'), this.$store.state.successToastOptions)
      this.reloadTable()
    },
    handlePlacingDeleted: function () {
      this.selectedPlacing = null
      this.showPlacingDetailsAction = false
      this.showToast(this.$t('placings.deleted_success'), this.$store.state.successToastOptions)
      this.reloadTable()
    },
    reloadTable: function () {
      //console.log(this.$refs.placingsTable)
      this.$refs.placingsTable.reload()
    }
  },
  filters: {
    coordinate: function (value) {
      return value.toFixed(6)
    }
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server) || null
    },
    entities: function () {
      let leadsPermissions = this.leadsService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === 200)
      if (leadsPermissions.length > 0) {
        if (leadsPermissions.some(permission => permission.entity_id === null)) {
          return [...this.leadsService.entities]
        } else {
          return leadsPermissions.map(permission => this.leadsService.entities.find(entity => permission.entity_id === entity.id)).filter(v => v)
        }
      }
    },
  }
}

</script>

<style lang="scss">

</style>
